var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('chart-title',[_vm._v("Cantidad de paquetes por semana, "),_c('br'),_vm._v(" según diferentes fuentes")]),_c('v-chart',{staticStyle:{"width":"100%"},attrs:{"options":_vm.counter,"autoresize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }